export default __webpack_public_path__ + "static/media/node js.4d8b9a0c.svg";